import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AllergyModel } from 'src/app/shared/services/models/medical-record/allergy.model';
import { MedicalProcedureStruct } from 'src/app/shared/services/structs/medical-record/medical-procedure.struct';
import { GetListMedicineStruct } from 'src/app/shared/services/structs/pharmacy/get-list-medicine.struct';
import { AlertModalComponent } from '../../alert-modal/alert-modal.component';
import { MedicalProcedureCheckRequest } from 'src/app/shared/services/requests/medical-record/medical-procedure-check.request';
import { PrescriptionMedicineCheckStruct } from 'src/app/shared/services/structs/pharmacy/prescription-medicine-check.struct';
import { PrescriptionSolutionCheckStruct } from 'src/app/shared/services/structs/pharmacy/prescription-solution-check.struct';
import { PrescriptionSolutionStruct } from 'src/app/shared/services/structs/pharmacy/prescription-solution.struct';
import { PrescriptionMedicineStruct } from 'src/app/shared/services/structs/pharmacy/prescription-medicine.struct';

@Component({
    selector: 'app-late-pending-checks-modal',
    templateUrl: './late-pending-checks-modal.component.html',
    styleUrls: ['./late-pending-checks-modal.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LatePendingChecksModalComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<LatePendingChecksModalComponent>,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  public prescriptionMedicineStruct: PrescriptionMedicineStruct;
  public medicalProcedureStruct: MedicalProcedureStruct;
  public prescriptionSolutionStruct: PrescriptionSolutionStruct;

  public patientName: string;
  public birthDate: Date;
  public idEpisode: number;
  public allergiesToSave: AllergyModel[] = [];
  public listMedicine: GetListMedicineStruct;

  public listPrescriptionMedicineCheck: PrescriptionMedicineCheckStruct[] = [];
  public listSolutionCheck: PrescriptionSolutionCheckStruct[] = [];
  public listCheckedProcedure: MedicalProcedureCheckRequest[] = [];

  public typeOfPendingCheck: string;

  ngOnInit(): void {
    this.setLocalVariablesFromData();
    this.setTypeOfPendingCheck();
  }

  setLocalVariablesFromData(): void {
    this.prescriptionMedicineStruct = this.data.prescriptionMedicineStruct;
    this.medicalProcedureStruct = this.data.medicalProcedureStruct;
    this.prescriptionSolutionStruct = this.data.prescriptionSolutionStruct;

    this.patientName = this.data.patientName;
    this.birthDate = this.data.birthDate;
    this.idEpisode = this.data.idEpisode;
    this.allergiesToSave = this.data.allergiesToSave;
    this.listMedicine = this.data.listMedicine;
  }

  setTypeOfPendingCheck(): void {
    if (this.prescriptionMedicineStruct) {
      this.typeOfPendingCheck = 'prescription';
    } else if (this.medicalProcedureStruct) {
      this.typeOfPendingCheck = 'procedure';
    } else if (this.prescriptionSolutionStruct) {
      this.typeOfPendingCheck = 'solution';
    }
  }

  async confirmEdit(): Promise<void> {
    let isTwoButtonsModal = false;
    let title = 'Atenção!';
    let description = 'As alterações realizadas somente serão salvas após o salvamento da conduta.';
    let hasImage = true;
    await this.openAlertModal(isTwoButtonsModal, title, description, hasImage);

    let result = {};

    if (this.typeOfPendingCheck === 'prescription') {
      result = {
        prescriptionMedicineStruct: this.prescriptionMedicineStruct,
        listPrescriptionMedicineCheckStruct: this.listPrescriptionMedicineCheck
      };
    }
    else if (this.typeOfPendingCheck === 'solution') {
      result = {
        prescriptionSolutionStruct: this.prescriptionSolutionStruct,
        listPrescriptionSolutionCheckStruct: this.listSolutionCheck
      };
    }
    else if (this.typeOfPendingCheck === 'procedure') {
      result = {
        medicalProcedureStruct: this.medicalProcedureStruct,
        listCheckedProcedure: this.listCheckedProcedure
      };
    }

    this.dialogRef.close(result);
  }

  async openAlertModal(isTwoButtonsModal: boolean, title: string, description: string, hasImage: boolean): Promise<void> {
      return new Promise((resolve) => {
        const dialogRef = this.dialog.open(AlertModalComponent, {
          data: {
            isTwoButtonsModal: isTwoButtonsModal,
            title: title,
            description: description,
            hasImage: hasImage
          },
        });
        dialogRef.afterClosed().subscribe({
          next: result => {
            resolve();
            return;
          }
        });
      });
  }

  cancelEdit(): void {
    this.dialogRef.close();
  }
}
